export default "__VITE_ASSET__a068787b__"